import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { NS } from '@/constants';
import { HtmlEntities } from '@/utils/HtmlEntities';
import styles from './ProductAttributesTable.module.scss';

const isAttrDisplayable = ({ displayable, usage }) => displayable === 'true' && usage !== 'Defining';

const ProductAttributesTable = ({ attributes, attributesRef, showTitle = false }) => {
	const { t } = useTranslation(NS.COMMON);

	return attributes?.length > 0 ? (
		<table className={styles.table} ref={attributesRef}>
			{showTitle && <caption>{t('product.details.plural')}</caption>}
			<tbody>
				{attributes.map((attr, i) =>
					isAttrDisplayable(attr) ? (
						<tr key={i}>
							<td className={styles.name}>{HtmlEntities.decode(attr.name)}</td>
							<td>{HtmlEntities.decode(attr.value)}</td>
						</tr>
					) : null,
				)}
			</tbody>
		</table>
	) : null;
};

ProductAttributesTable.propTypes = {
	attributes: PropTypes.array,
	attributesRef: PropTypes.object,
	showTitle: PropTypes.bool,
};

export default ProductAttributesTable;
